module.exports = __webpack_public_path__ + "static/media/Email-icon.c66d215a.svg";